import { render, staticRenderFns } from "./IntegraFollow.vue?vue&type=template&id=0c3c357a&scoped=true"
import script from "./IntegraFollow.vue?vue&type=script&lang=js"
export * from "./IntegraFollow.vue?vue&type=script&lang=js"
import style0 from "./IntegraFollow.vue?vue&type=style&index=0&id=0c3c357a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3c357a",
  null
  
)

export default component.exports